// extracted by mini-css-extract-plugin
module.exports = {"root":"_3ajJpzDOuB1_N614oD3i9v","icon":"_2XfAxKvHDOLbD2PKe4oqJ1"};